import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { Mode } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import virtualClassroomManagerRoutes from 'modules/virtualClassrooms/common/routing/managerRoutes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const EventDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "VirtualClassroomManagerEventDetails" */ 'modules/virtualClassrooms/manager/EventDetails/pages/EventDetails'
    )
)

const EventDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress mode={Mode.Light} />}>
    <Switch>
      <Route path={`${routes.root}/:eventId`} component={EventDetails} />
      <Redirect path='*' to={virtualClassroomManagerRoutes.events} />
    </Switch>
  </Suspense>
)

export default EventDetailsRouting
